<template>
  <q-page class="column">
    <PuilTable
      :rows="puils"
      v-model:pagination="pagination"
      @del="excluirPuil"
      @request="fetchPuilTablePage"
    />
  </q-page>
</template>

<script setup>
import PuilTable from "@/components/puil/PuilTable.vue";
import {
  baseUrlDelete,
  DELETE_FAILURE,
  DELETE_SUCCESS
} from "@/DemandasRepetitivas";
import { useAppStore } from "@/store/app-store";
import { usePuilStore } from "@/store/puil-store";
import { useQuasar } from "quasar";
import { computed, watch, ref } from "vue";
PuilTable;

const quasar = useQuasar();
const puilStore = usePuilStore();
puilStore.fetchPage(1, 10);
const appStore = useAppStore();
appStore.drawerExpanded = true

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  get rowsNumber() {
    return temasCount.value;
  },
  set rowsNumber(v) {
    temasCount.value = v;
  }
});

const temasCount = computed(() => puilStore.temasCount);
const currentPage = computed(() => pagination.value?.page);
watch(temasCount, () => (pagination.value.rowsNumber = temasCount.value));
watch(currentPage, () => (puilStore.page = currentPage.value));

const puils = computed(() => puilStore.pages[pagination.value.page]);

const fetchPuilTablePage = props => {
  Object.assign(pagination.value, props.pagination);
  props.pagination.rowsPerPage = props.pagination.rowsPerPage == 0 ? temasCount.value : props.pagination.rowsPerPage;
  fetchTemasPage(props.pagination.page, props.pagination.rowsPerPage);
};

const search = () => fetchTemasPage(1);
const fetchTemasPage = (page = 1, rowsPerPage = 10) => puilStore.fetchPage(page, rowsPerPage);

const excluirPuil = id => {
  const reload = search;
  const failure = () => notify(DELETE_FAILURE, "negative");
  const success = () => notify(DELETE_SUCCESS, "positive");

  const successAndReload = () => {
    success();
    reload();
  };
  const httpOk = r => r.status == 200;
  const readResponse = r => (httpOk(r) ? successAndReload() : failure());

  baseUrlDelete(`pedido-uniformizacao/${id}`)
    .then(readResponse)
    .catch(failure);
};

const notify = (msg, color) => {
  const notifyObj = (message, color) => ({ message, color });
  quasar.notify(notifyObj(msg, color));
};
</script>
